<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <promo-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import PromoShowData from "./PromoShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "PromoShow",
        components: {CrudShow, PromoShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.promo.showing',
            }
        },
    }
</script>

